module.exports = __webpack_public_path__ + "img/unlink3.47668101.png";